var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHappy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.047,
    height: 328.051,
    viewBox: "0 0 328.047 328.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a_iconHappy{opacity:0.05;}.b_iconHappy{fill:#00aec7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a_iconHappy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b_iconHappy",
    d: "M392.54-8.346a9.442,9.442,0,0,1-6.69-2.77A9.454,9.454,0,0,1,384-21.871l40.183-84.389a153.271,153.271,0,0,1-20.5-76.889A152.486,152.486,0,0,1,448.81-291.616,152.486,152.486,0,0,1,557.168-336.4h.329a153.518,153.518,0,0,1,80.98,23.068c72.011,44.652,94.269,139.568,49.617,211.576C644.364-31.225,552.422-8.418,481-49.457L396.6-9.262A9.459,9.459,0,0,1,392.54-8.346ZM557.168-317.477c-74.1,0-134.453,60.224-134.57,134.359A134.44,134.44,0,0,0,442.93-111.77a9.449,9.449,0,0,1,.511,9.067l-30.9,64.893,64.893-30.9a9.436,9.436,0,0,1,9.051.5c63.153,39.154,146.376,19.639,185.531-43.51s19.636-146.376-43.51-185.531A134.645,134.645,0,0,0,557.5-317.477h-.329Z",
    transform: "translate(-383.077 336.397)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.517 120.962)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b_iconHappy",
    d: "M424.333-278.749a12.857,12.857,0,0,1-12.843-12.843,12.857,12.857,0,0,1,12.843-12.839,12.857,12.857,0,0,1,12.844,12.839A12.858,12.858,0,0,1,424.333-278.749Z",
    transform: "translate(-411.49 304.431)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.046 120.962)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b_iconHappy",
    d: "M452.749-278.749a12.857,12.857,0,0,1-12.843-12.843,12.857,12.857,0,0,1,12.843-12.839,12.857,12.857,0,0,1,12.843,12.839A12.857,12.857,0,0,1,452.749-278.749Z",
    transform: "translate(-439.906 304.431)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.039 168.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b_iconHappy",
    d: "M460.765-239.5h-.023a43.116,43.116,0,0,1-43.036-43.041,9.46,9.46,0,0,1,2.77-6.69,9.464,9.464,0,0,1,6.69-2.774h67.2a9.463,9.463,0,0,1,6.69,2.774,9.461,9.461,0,0,1,2.77,6.69A43.114,43.114,0,0,1,460.765-239.5Zm-22.2-33.584a24.176,24.176,0,0,0,22.186,14.663h.012a24.186,24.186,0,0,0,22.205-14.663Z",
    transform: "translate(-417.706 292)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappy);
export default __webpack_public_path__ + "static/media/icon-happy.760a30359e8a50d741b1410585f062ba.svg";
export { ForwardRef as ReactComponent };